var _style, _path, _line, _line2, _path2, _path3, _polyline, _path4, _line3, _path5, _line4, _path6, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostureResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,10.9h-12l1.1-5.2c0,0,0.1-2.6,2.8-2.6c2.7,0,4.6,0,4.6,0S18,2.8,18.7,5C19.1,7.2,19.8,10.9,19.8,10.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.9,
    y1: 10.9,
    x2: 14.9,
    y2: 22.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.6,
    y1: 10.9,
    x2: 12.6,
    y2: 22.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,20.9h-4.2c0,0-1.6,0.7-0.9,2c0.3,0.5,0.3,0.8,3.1,0.7s2.1,0,2.1,0s1.9,0.2,1.8-1.8s0.3-6.2-5-8 c-1-0.1-4.3-0.7-6.8,1.2c-0.8,0.7-2.8,2-2.7,6.5c0,0.7-0.2,2.2,2.1,2.2s3.5,0,3.5,0s1.8,0.2,1.7-1.8c-0.1-0.3-0.1-1.2-2.1-1 c-2.3,0-3.4,0-3.4,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,23.6c0,0-2.3,1.3-1.8,7c0,1.8,0.1,3.5,0.1,3.5s-0.1,1.9,1.5,2.1c0.8-0.1,2.1,0.5,2.3-3.8 c0.2-2.4,0-5,1.6-5.6c0.7,0,2.5-0.4,2.7,2.7c0.2,2.8,0.4,4.5,0.4,4.5s0.1,1.9,1.6,2.1c0.7,0,2-0.1,2-2.3s0-6.9,0-6.9 s-0.4-2.8-2.6-3.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "21.4,26.4 7.1,26.4 7.1,36.3 37,36.3 37,26.4 33.5,26.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.6,20.3c0,0-2.9-0.7-2.7-2.8c0.1-1.1,0.6-2.8,3-2.8c0.9,0,3.4-0.1,3.6,2.8c0,2.4,0,8.7,0,8.7"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.1,
    y1: 17.6,
    x2: 7.1,
    y2: 26.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,23h5.7c0,0,2-0.4,1.9,1.5c0,1,0,1.7,0,1.7"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.3,
    y1: 11.1,
    x2: 18.3,
    y2: 15.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,15.3c0,0,1.5,0,0.9,2.1c-0.3,0.8-0.9,1.2-0.9,1.2s-1.4-0.4-1.2-2.6l0,0C17.1,15.9,17.4,15.1,18.3,15.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.6,
    cy: 9.7,
    r: 3.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostureResting);
export default __webpack_public_path__ + "static/media/PostureResting.6888b8d749d001ecd69704cfb13e7500.svg";
export { ForwardRef as ReactComponent };